// import logo from './logo.svg';
import './App.css';
import { Route, Routes } from 'react-router-dom';

import HeaderMiddle from './components/Header/Middle/HeaderMiddle';
import HeaderSmall from './components/Header/Small/HeaderSmall';

import Home from './pages/Home/Home';
import Work from './pages/Work/Work';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
// import HeaderBig from './components/Header/Big/HeaderBig';
import Footer from './components/Footer/Footer';
// import FooterDesktop from './components/Footer/FooterDesktop/FooterDesktop';
// import { useTranslation } from 'react-i18next';

function App() {
  // const { t, i18n } = useTranslation();

  // useEffect(() => {
  //   const lng = navigator.language;

  //   i18n.changeLanguage(lng);
  // }, []);
  return (
    <div className='App'>
      {/* <header className=""> */}
      <HeaderSmall />
      <HeaderMiddle />
      {/* </header> */}

      {/* <HeaderBig /> */}

      <main className='main-container' role='main'>
        <Routes>
          <Route path='/' exact element={<Home />} />
          <Route path='/work' element={<Work />} />
          <Route path='/about' element={<About />} />
          <Route path='/contact' element={<Contact />} />
        </Routes>
      </main>

      <Footer />
      {/* <FooterDesktop /> */}
    </div>
  );
}

export default App;
